





























































































// Vue
import { Vue, Component, Prop } from 'vue-property-decorator'

// models
import { ChildModel } from '@/models/config'

// components
import { Input, Select, DatePicker } from '@/components/form'

// constants
import { documentTypes } from '@/constants'

@Component({
    name: 'TableChildren',
    components: {
        Input,
        Select,
        DatePicker
    }
})
export default class TableChildren extends Vue {
    @Prop({ required: true }) children!: ChildModel[]
    @Prop({ type: [Array, Object], default: () => ([]) }) validations!: []

    documentTypes = documentTypes
}
